/**
 * The rows out of a listing response.
 *
 * The backend answers listings as `{ items, total, skip, limit }` and a few
 * reads as a bare array. Every call site used to know which — and got it wrong
 * the moment an endpoint changed shape, silently, because `undefined.length`
 * is falsy rather than an error and a carousel with nothing to map over looks
 * like an empty category.
 *
 * This is the one place that knows the envelope. It accepts either form, so a
 * route that has not been migrated still renders.
 */
export function itemsOf<T = unknown>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload as T[];

  if (payload && typeof payload === 'object') {
    const items = (payload as { items?: unknown }).items;
    if (Array.isArray(items)) return items as T[];

    // The name the previous backend used. Kept so a mixed deployment renders.
    const events = (payload as { events?: unknown }).events;
    if (Array.isArray(events)) return events as T[];
  }

  return [];
}

/** How many rows the filter matches in total, not just on this page. */
export function totalOf(payload: unknown, fallback = 0): number {
  if (payload && typeof payload === 'object') {
    const total = (payload as { total?: unknown }).total;
    if (typeof total === 'number' && Number.isFinite(total)) return total;
  }
  return fallback;
}
